import React from "react";
import type { FormData } from "../types";

interface CustomInstructionsSectionProps {
  formData: FormData;
  onFormChange: (field: keyof FormData, value: any) => void;
}

const CustomInstructionsSection: React.FC<CustomInstructionsSectionProps> = ({
  formData,
  onFormChange,
}) => {
  return (
    <div className="md:col-span-2">
      <label className="block text-sm font-medium mb-2 text-(--text-secondary)">
        Instruções Personalizadas (Opcional)
      </label>
      <textarea
        value={formData.customInstructions}
        onChange={(e) => onFormChange("customInstructions", e.target.value)}
        rows={3}
        className="w-full p-3 border border-(--border-color) rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition bg-(--input-bg) text-(--text-primary)"
        placeholder="Ex: Foco em exemplos práticos, usar linguagem acessível, incluir atividades interativas..."
      />
    </div>
  );
};

export default CustomInstructionsSection;
